(() => {
  // app/scripts/slider-component.js
  var customElementsName = "slider-component";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      connectedCallback() {
        let config = this.querySelector('script[type*="json"]');
        if (!config)
          return;
        this.config = JSON.parse(config.innerHTML);
        if (this.hasAttribute("slide-wait"))
          return;
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting)
              return;
            observer.unobserve(this);
            this.isIntersecting = true;
            this.createSlide();
          },
          { rootMargin: "400px 0px 400px 0px" }
        );
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (!this.isIntersecting)
          this.observer?.unobserve(this);
        this.unLoad();
      }
      load(config = {}) {
        this.config = { ...this.config, ...config };
        this.createSlide();
      }
      createSlide() {
        if (this.slider || !this.querySelector(".js-slider").childElementCount)
          return;
        if (!window.SwiperSlider) {
          setTimeout(() => this.load(), 50);
          return;
        }
        const { Swiper, Modules } = window.SwiperSlider;
        this.config.spaceBetween && (this.config.spaceBetween = +this.config.spaceBetween.toString().replace(/[^\d.,]/g, ""));
        const sliderContainer = this.querySelector(".js-slider");
        let slides = Array.from(sliderContainer.children);
        let maxSlidesPerView = Math.max(...Object.values(this.config.breakpoints || {}).map((bp) => bp.slidesPerView || 1));
        if (this.config.loop && slides.length < maxSlidesPerView * 2) {
          slides.forEach((slide) => {
            let clone = slide.cloneNode(true);
            sliderContainer.appendChild(clone);
          });
        }
        for (let i in this.config.breakpoints) {
          let spaceBetween = this.config.breakpoints[i]?.spaceBetween || 0;
          this.config.breakpoints[i].spaceBetween = +spaceBetween.toString().replace(/[^\d.,]/g, "");
        }
        this.slider = new Swiper(this, {
          init: false,
          ...this.config,
          modules: Modules
        });
        this.slider.on("init", this.onInit.bind(this));
        this.slider.on("breakpoint", (e) => {
          this.classList.toggle("slider-slide-enabled", e.enabled);
          this.querySelector(".js-slider")?.classList.toggle("slider-loaded", e.enabled);
          this.querySelector(".js-slider")?.classList.toggle("items-nobreak", e.enabled);
          this.querySelector(".js-slider")?.classList.toggle("grid-flow-col", e.enabled);
        });
        if (this.classList.contains("categories-slider")) {
          const debounceTime = theme.debounceTime;
          this.slider.on(
            "transitionEnd",
            debounceTime((e) => {
              if (this.slider.activeIndex == 0) {
                this.classList.remove("slider-shadow");
              }
            }, 100)
          );
          this.slider.on(
            "sliderMove",
            debounceTime((e) => {
              this.classList.add("slider-shadow");
            }, 100)
          );
        }
        this.slider.init();
        return this.slider;
      }
      onChange(e) {
        const slideIndex = this.querySelector(".jsSlideIndex");
        if (!slideIndex)
          return;
        slideIndex.innerHTML = e.index + 1;
      }
      onInit(e) {
        this.removeAttribute("slide-wait");
        const emptySlides = [...this.querySelectorAll(".swiper-slide")].filter((slide) => {
          const emptyContent = slide.querySelector(".swiper-slide-content-empty");
          return !!emptyContent;
        });
        if (emptySlides.length == this.querySelectorAll(".swiper-slide").length) {
          this.classList.add("slider-is-empty");
        }
        this.classList.add("slider-component-loaded");
        this.classList.toggle("slider-slide-enabled", e.enabled);
        this.querySelector(".js-slider")?.classList.toggle("slider-loaded", e.enabled);
        this.querySelector(".js-slider")?.classList.toggle("items-nobreak", e.enabled);
        this.querySelector(".js-slider")?.classList.toggle("grid-flow-col", e.enabled);
        window.dispatchEvent(new Event("lazy:update"));
      }
      getSlide() {
        return this.slider;
      }
      unLoad() {
        if (!this.slider || !this.slider.destroy)
          return;
        this.slider.destroy();
      }
      goTo(index) {
        if (index == "next")
          this.slider?.slideNext();
        else if (index == "prev")
          this.slider?.slidePrev();
        else
          this.slider?.slideTo(index);
      }
    }
  );
})();
